import { BaseTool, ToolContext } from '../BaseTool';
import { View } from '../../core/types';
import { v4 as uuidv4 } from 'uuid';

/**
 * One-shot view creators for the plan-family 2D view types that need no
 * sketch: Drafting views and Legend views. Both register a real View in the
 * project (visible in the Project Browser) and switch the viewport to it.
 */
function createAndActivate2DView(context: ToolContext | null, type: 'Drafting' | 'Legend', label: string) {
    if (!context) return;
    const viewId = uuidv4();
    const existing = Array.from(context.bimStore.project.views.values()).filter(v => v.type === type).length;
    const view: View = {
        id: viewId,
        name: `${label} ${existing + 1}`,
        type,
        scale: 20,
        detailLevel: 'Fine',
        visibility: {},
        filters: [],
        camera: {
            position: [0, 0, 50],
            target: [0, 0, 0],
            projection: 'Orthographic',
        },
    };
    context.bimStore.addView(view);
    context.bimStore.setActiveView(viewId);
}

export class DraftingViewTool extends BaseTool {
    id = 'VIEW_DRAFTING';
    name = 'Drafting View';
    cursor = 'default';

    onActivate(): void {
        createAndActivate2DView(this.context, 'Drafting', 'Drafting View');
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

export class LegendViewTool extends BaseTool {
    id = 'VIEW_LEGEND';
    name = 'Create Legend';
    cursor = 'default';

    onActivate(): void {
        createAndActivate2DView(this.context, 'Legend', 'Legend');
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
